export default {
  'component.tagSelect.expand': '展开',
  'component.tagSelect.collapse': '收起',
  'component.tagSelect.all': '全部',

  // ControlledRepository component
  'component.controlledRepository.documentId': '文档ID',
  'component.controlledRepository.documentName': '文档名称',
  'component.controlledRepository.version': '版本',
  'component.controlledRepository.process': '过程',
  'component.controlledRepository.status': '状态',
  'component.controlledRepository.baseline': '基线',
  'component.controlledRepository.owner': '责任人',
  'component.controlledRepository.searchPlaceholder': '搜索文档名称或ID',
  'component.controlledRepository.selectProcessPlaceholder': '选择过程',
  'component.controlledRepository.selectBaselinePlaceholder': '选择基线',
  'component.controlledRepository.search': '搜索',
  'component.controlledRepository.updateBaseline': '更新基线',
  'component.controlledRepository.updateDocumentBaseline': '更新文档基线',
  'component.controlledRepository.selectBaseline': '选择基线',
  'component.controlledRepository.removeBaseline': '-- 移除基线 --',
  'component.controlledRepository.removeBaselineDesc': '选择"移除基线"将解除文档与基线的关联',
  'component.controlledRepository.selectBaselineRequired': '请选择基线',
  'component.controlledRepository.updateBaselineSuccess': '文档基线更新成功',
  'component.controlledRepository.updateBaselineFailed': '文档基线更新失败',
  'component.controlledRepository.getDocumentsFailed': '获取文档列表失败',
  'component.controlledRepository.getProcessesFailed': '获取过程列表失败',
  'component.controlledRepository.getBaselinesFailed': '获取基线列表失败',
  'component.controlledRepository.notInBaseline': '未纳入基线',

  // Document status
  'component.controlledRepository.status.draft': '草稿',
  'component.controlledRepository.status.draftLocked': '草稿锁定',
  'component.controlledRepository.status.review': '评审中',
  'component.controlledRepository.status.reviewPassed': '评审通过',
  'component.controlledRepository.status.auditPassed': '审核通过',
  'component.controlledRepository.status.approved': '已批准',
  'component.controlledRepository.status.controlled': '已受控',
  'component.controlledRepository.status.published': '已发布',
  'component.controlledRepository.status.obsolete': '已废弃',

  // CreateDocumentModal component
  'component.createDocumentModal.analyzingData': '正在分析对接系统数据...',
  'component.createDocumentModal.findingTemplate': '正在查找系统模板...',
  'component.createDocumentModal.understandingStructure': '正在理解文档结构...',
  'component.createDocumentModal.callingAI': '正在调用 AI 服务...',
  'component.createDocumentModal.generatingContent': '正在生成文档内容...',
  'component.createDocumentModal.optimizingOutput': '正在优化输出结果...',
  'component.createDocumentModal.projectNotFound': '未找到当前项目',
  'component.createDocumentModal.createFromTemplateSuccess': '从模板创建工作成果成功',
  'component.createDocumentModal.createFromExistingSuccess': '从已有工作成果创建成功',
  'component.createDocumentModal.createFromLocalSuccess': '从本地文件创建工作成果成功',
  'component.createDocumentModal.createFromIntegrateSuccess': '从对接系统创建工作成果成功',
  'component.createDocumentModal.createFailed': '创建失败',
  'component.createDocumentModal.permissionDenied': '权限不足，请联系管理员',
  'component.createDocumentModal.resourceNotFound': '资源不存在，请检查配置',
  'component.createDocumentModal.serverError': '服务器内部错误，请稍后重试',
  'component.createDocumentModal.uploadFileFirst': '请先上传文件',
  'component.createDocumentModal.fileNotExist': '文件不存在或未成功上传',
  'component.createDocumentModal.fileParseFailed': '文件内容解析失败',
  'component.createDocumentModal.creatingDocument': '正在创建文档...',
  'component.createDocumentModal.createDocumentFailed': '创建文档失败',
  'component.createDocumentModal.fileUploadFailed': '文件上传失败',
  'component.createDocumentModal.canceled': '已取消文档生成',
  'component.createDocumentModal.csvData': 'CSV数据',
  'component.createDocumentModal.headers': '表头',
  'component.createDocumentModal.data': '数据',
  'component.createDocumentModal.excelData': 'Excel数据',
  'component.createDocumentModal.columnNames': '列名',
  'component.createDocumentModal.wordContent': 'Word文档内容',

  // TraceabilityComponent component
  'component.traceability.viewDocument': '查看文档',
  'component.traceability.notConfigured': '未配置',
  'component.traceability.configureTraceColumn': '配置追溯列',
  'component.traceability.selectTraceItems': '选择要追溯的数据项',
  'component.traceability.selectTraceItemsButton': '选择追溯项',
  'component.traceability.unknown': '未知',
  'component.traceability.noTraceabilityData': '未配置追溯数据集',
  'component.traceability.noTraceData': '无追溯数据',
  'component.traceability.configureTraceColumnTitle': '配置追溯列',
  'component.traceability.confirm': '确认',
  'component.traceability.cancel': '取消',
  'component.traceability.selectTraceColumn': '选择追溯列',
  'component.traceability.selectTraceColumnPlaceholder': '选择追溯列',
  'component.traceability.selectTraceItemsTitle': '选择追溯项',
  'component.traceability.selectAll': '全选',
  'component.traceability.selectTraceItemsDesc': '请选择要追溯的数据项',
  'component.traceability.process': '过程',
  'component.traceability.workProduct': '工作成果',
  'component.traceability.traceColumn': '追溯列',
  'component.traceability.traceItems': '追溯项',
  'component.traceability.searchTraceItems': '搜索章节或内容',
  'component.traceability.ungrouped': '未分组',
  'component.traceability.traceItemCount': '共 {{count}} 项',
  'component.traceability.expiredCount': '失效 {{count}} 项',
  'component.traceability.expiredTraceItems': '失效项（源文档中已找不到对应内容）',
  'component.traceability.changedCount': '内容已变更 {{count}} 项',
  'component.traceability.changedTraceItems': '内容已变更（编号未变）',
  'component.traceability.updateTraceRefs': '更新引用',
  'component.traceability.traceRefsUpdated': '已把 {{count}} 个引用对齐到最新内容',
  'component.traceability.extraTraceItems': '未纳入追溯矩阵的已选项',
  'component.traceability.extraCount': '未纳入矩阵 {{count}} 项',
  'component.traceability.scopedHint': '仅显示追溯矩阵中已配置的条目',
  'component.traceability.showAllTraceItems': '显示全部 {{count}} 项',
  'component.traceability.noMatch': '没有匹配的条目',
  'component.traceability.unmatchedTitle': '有 {{count}} 项已配置的追溯项没匹配到当前内容',
  'component.traceability.unmatchedDesc':
    '通常是正文已修改但尚未保存（保存后 ID 会重新对齐），或者本过程换了另一份文档。可勾选「显示全部 {{total}} 项」继续查找。',
  'component.traceability.noTraceColumnTitle': '尚未配置追溯项',
  'component.traceability.noTraceColumnDesc':
    '请先在 {{process}} 过程页的「追溯矩阵」中点击「选择追溯项」，挑出需要被下游覆盖的条目，之后再回到这里勾选。下面暂且显示全部 {{count}} 项。',
  'component.traceability.done': '完成',
  'component.traceability.summaryTable': '追溯汇总表',
  'component.traceability.summaryTableTip':
    '把本章已插入的追溯引用块汇总成一张表，追加到章节末尾；重复生成会替换上一张',
  'component.traceability.insertTargetAppend': '章末',
  'component.traceability.insertTargetCursor': '光标处',
  'component.traceability.insertOnlyHintAppend':
    '勾选即把{{source}}引用追加到本章节末尾，取消勾选即从正文移除；追溯关系与正文内容始终一致。',
  'component.traceability.insertOnlyHintCursor':
    '勾选即在光标处插入{{source}}引用，取消勾选即从正文移除；追溯关系与正文内容始终一致。',
  // 抽屉作用域：引用来自上游文档 / 本文档其它章节 / 两者都有
  'component.traceability.sourceUpstream': '上游条目的',
  'component.traceability.sourceSelf': '本文档其它章节的',
  'component.traceability.sourceAll': '追溯对象的',
  'component.traceability.noUpstreamDoc': '本过程还没有上游追溯文档，请先在项目中配置上游文档',
  'component.traceability.noSelfBlocks':
    '本文档还没有可作为追溯对象的段落或表格行，先写点内容再来引用',
  'component.traceability.resetDrawerTip': '恢复默认位置与尺寸，下次打开重新按光标避让',
  'component.traceability.drawerReset': '已复位抽屉位置与尺寸',
  'component.traceability.traceUpdatedNeedSave': '追溯已写入正文，请点页面「保存」生效',
  'component.traceability.generateSummaryTable': '生成本章追溯汇总表',
  'component.traceability.summaryTableGenerated': '已生成包含 {{count}} 条追溯项的汇总表',
  'component.traceability.noRefToSummarize': '本章还没有插入任何追溯引用块。',
  'component.traceability.refInserted': '已插入 {{count}} 个追溯引用到正文',
  'component.traceability.refRemoved': '已从正文移除 {{count}} 个追溯引用',
  'component.traceability.declaredOnly': '未插入正文',
  'component.traceability.declaredOnlyTip':
    '历史勾选记录：正文里还没有对应的引用块。取消再勾选即可真正插入正文。',
  'component.traceability.orphanCannotInsert':
    '失效项在源文档中已不存在，无法插入正文，只能取消勾选。',
  'component.traceability.insertOnlyHint':
    '勾选即在正文中插入追溯引用块，取消勾选即从正文移除；追溯关系与正文内容始终一致。',

  // 同一条目多处引用
  'component.traceability.refInsertedAgain': '已新增 {{count}} 处追溯引用',
  'component.traceability.alreadyReferenced':
    '本章节已引用过这些条目；若要多引用一处，请点条目行尾的 +',
  'component.traceability.multiRefTip': '本章节已引用 {{count}} 处',
  'component.traceability.insertAgainTip': '在光标处再插入一处引用（本章已引用 {{count}} 处）',
  'component.traceability.insertHereTip': '在光标处插入一处引用',
  'component.traceability.removeMultiRefsTitle': '移除全部引用？',
  'component.traceability.removeMultiRefsContent':
    '有 {{items}} 个条目在本章节被引用了多处（共 {{refs}} 处）。取消勾选会把这些引用全部移除；若只想删其中一处，请直接在正文里删除对应标记。',
  'component.traceability.removeAll': '全部移除',

  // 追溯详情（策略 1）
  'component.traceability.clickForDetail': '点击查看引用位置',
  'component.traceability.detailTitle': '追溯详情',
  'component.traceability.detailUpstream': '上游项',
  'component.traceability.detailDownstream': '下游文档',
  'component.traceability.detailHitCount': '共 {{count}} 处引用',
  'component.traceability.detailNoChapter': '未标注章节',
  'component.traceability.detailNoSnippet': '仅声明了追溯关系，正文里没有可定位的引用位置',
  'component.traceability.snippetContext': '上文',
  'component.traceability.snippetContextPrefix': '（上文）',
  'component.traceability.blockTypeParagraph': '段落',
  'component.traceability.blockTypeTableRow': '表格行',
  'component.traceability.blockTypeCell': '单元格',
  'component.traceability.sourceRef': '正文引用',
  'component.traceability.sourceDeclared': '声明式配置',
  'component.traceability.sourceRefTip': '正文里真实插入的引用块，精确到段落 / 表格行',
  'component.traceability.sourceDeclaredTip': '历史「只勾不选」的配置，只能定位到章节',

  // 导出追溯报告（策略 5）
  'component.traceability.exportReport': '导出追溯报告',
  'component.traceability.exportReportTip':
    '导出 Excel：概览 / 每条追溯关系一张成对表 / 未覆盖清单 / 失效引用，可直接作为评审证据',
  'component.traceability.previewReport': '预览追溯报告',
  'component.traceability.previewReportTip':
    '先在屏幕上核对一遍再导出：表结构、行序与导出的 Excel 完全一致',
  'component.traceability.previewTitle': '追溯报告预览',
  'component.traceability.previewClose': '关闭',
  'component.traceability.previewRelationTable': '追溯关系汇总',
  'component.traceability.previewTotal': '共 {{count}} 行',
  'component.traceability.previewEmpty': '本表没有数据',
  'component.traceability.exportSuccess': '追溯报告已导出',
  'component.traceability.exportFail': '导出追溯报告失败',
  'component.traceability.exportEmpty': '还没有追溯数据可导出',
  'component.traceability.reportFileName': '追溯报告',
  'component.traceability.reportSheetOverview': '概览',
  'component.traceability.reportSheetUncovered': '未覆盖清单',
  'component.traceability.reportSheetExpired': '失效引用',
  'component.traceability.reportProject': '项目',
  'component.traceability.reportGeneratedAt': '生成时间',
  'component.traceability.reportUpstreamCount': '追溯对象数',
  'component.traceability.reportDownstreamCount': '下游过程数',
  'component.traceability.reportHitCount': '引用总处数',
  'component.traceability.reportCoveredCount': '已覆盖项数',
  'component.traceability.reportUncoveredCount': '未覆盖项数',
  'component.traceability.reportCoverage': '覆盖率',
  'component.traceability.reportExpiredCount': '失效项数',
  'component.traceability.reportColRelation': '追溯关系',
  'component.traceability.reportColInvolvedProcess': '涉及过程',
  'component.traceability.noHitRow': '该过程未引用本过程的任何追溯对象',
  'component.traceability.noWorkProductRow': '该过程暂无工作产品，无法追溯',
  'component.traceability.reportColIndex': '序号',
  'component.traceability.reportColSelfProcess': '本过程',
  'component.traceability.reportColTraceId': '追溯对象ID',
  'component.traceability.reportColTraceDesc': '追溯对象描述',
  'component.traceability.reportColDownProcess': '下游过程',
  'component.traceability.reportColDownDoc': '下游文档',
  'component.traceability.reportColChapter': '章节',
  'component.traceability.reportColBlock': '位置',
  'component.traceability.reportColSource': '引用方式',
  'component.traceability.reportColDownId': '下游追溯ID',
  'component.traceability.reportColDownDesc': '下游追溯描述',
  'component.traceability.reportColUncoveredBy': '未覆盖的下游过程',
  'component.traceability.reportColCoveredRatio': '已覆盖/下游总数',
  'component.traceability.reportColKind': '类型',
  'component.traceability.reportColWhere': '位置',
  'component.traceability.reportColRemark': '说明',
  'component.traceability.expiredKindUpstream': '上游声明已失效',
  'component.traceability.expiredKindDownstream': '下游引用已失效',
  'component.traceability.expiredKindBareId': '裸块 ID（历史遗留）',
  'component.traceability.expiredUpstreamDesc':
    '源文档当前内容里已找不到对应条目，通常是正文改过导致 ID 漂移',
  'component.traceability.expiredDownstreamDesc': '下游正文引用了该 ID，但上游已无对应条目',

  // AIGeneratingModal component
  'component.aiGenerating.title': 'AI 正在生成文档',
  'component.aiGenerating.description': '基于您的需求生成文档',
  'component.aiGenerating.cancel': '取消生成',

  // AIGenerateModal component - Progress texts
  'component.aiGenerate.analyzingRequirements': '正在分析需求...',
  'component.aiGenerate.findingTemplates': '正在查找系统模板...',
  'component.aiGenerate.understandingStructure': '正在理解文档结构...',
  'component.aiGenerate.callingAI': '正在调用 AI 服务...',
  'component.aiGenerate.generatingContent': '正在生成文档内容...',
  'component.aiGenerate.optimizingResults': '正在优化输出结果...',
  'component.aiGenerate.analyzingContent': '正在分析文档内容...',
  'component.aiGenerate.understandingRequirements': '正在理解用户需求...',
  'component.aiGenerate.generatingRelatedContent': '正在生成相关内容...',

  // AIGenerateModal component - Error messages
  'component.aiGenerate.resourceNotFound': '未找到相关资源，请检查配置',
  'component.aiGenerate.permissionDenied': '权限不足，请联系管理员',
  'component.aiGenerate.serverError': '服务器内部错误，请稍后重试',
  'component.aiGenerate.requestFailed': '请求失败，请稍后重试',
  'component.aiGenerate.cancelled': '已取消文档生成',
  'component.aiGenerate.failedTitle': 'AI 文档生成失败',
  'component.aiGenerate.errorDetails': '错误详情：',
  'component.aiGenerate.possibleSolutions': '可能的解决方案：',
  'component.aiGenerate.checkTemplates': '检查是否存在标签为"内置模板"的模板',
  'component.aiGenerate.checkAIConfig': '确认 AI 服务配置是否正确',
  'component.aiGenerate.checkNetwork': '检查网络连接是否正常',
  'component.aiGenerate.retryOrContact': '稍后重试或联系管理员',
  'component.aiGenerate.generationFailed': '生成失败',

  // ExportProgressModal component
  'component.exportProgress.title': '导出进度',

  // BaselineList component
  'component.baselineList.untitledDocument': '未命名文档',
  'component.baselineList.wordBlobError': '无法获取Word文档的Blob数据',
  'component.baselineList.wordTimeoutError': '导出Word文档超时',
};
